export default () => ({
  messageModal: {
    header: 'Estimating leads',
    description: 'Estimates are calculated based on the median lead prices for your services in the US. Actual lead cost may be higher or lower based on the project and demand in your area. ' +
      '\n\nLead volume isn’t guaranteed.',
    'button-text': 'Got it',
  },
});



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/data/MessageModalConfig.js